import { ChatDiagnosticsStringViewer } from "@mirage/mosaics/ConversationAssistant/containers/ConversationAssistantPageContent/diagnostics/ChatDiagnosticsStringViewer";
import { ChatDiagnosticsViewerNode } from "@mirage/mosaics/ConversationAssistant/containers/ConversationAssistantPageContent/diagnostics/ChatDiagnosticsViewerNode";
import {
  AnswersWorkflowErrorCode,
  type AnswersWorkflowError,
  type AnswersWorkflowProcess,
} from "@mirage/service-dbx-api/service/grpc/context_engine_apiv2/gen/answers_pb";

export const WorkflowErrorsUI = ({
  errors = [],
  namePrefix,
}: {
  errors: AnswersWorkflowError[];
  process: AnswersWorkflowProcess;
  namePrefix: string;
}) => {
  const getErrorTitle = (error: AnswersWorkflowError) => {
    let name = AnswersWorkflowErrorCode[error.errorCode];
    if (namePrefix) {
      name = `${namePrefix} ${name}`;
    }
    return name;
  };

  return (
    <div>
      {errors.map((error, i) => (
        <ChatDiagnosticsViewerNode
          title={getErrorTitle(error)}
          subheader={error.displayName}
          isError={true}
          key={i}
        >
          <ChatDiagnosticsStringViewer content={error.message} />
        </ChatDiagnosticsViewerNode>
      ))}
    </div>
  );
};
